import React from "react";
import StackNavigator from "../../components/StackNavigator";
import Cart from "./Cart";
import PlaceOrder from "./PlaceOrder";

function CartScreens() {
  const SCREENS = [
    { name: "cartscreen", component: Cart },
    { name: "placeorder", component: PlaceOrder },
  ];
  return <StackNavigator screens={SCREENS} />;
}

export default CartScreens;
